var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeFacetsForQuery } from '../../lib/facet';
import { makeAndFiltersForQuery, makeNegativeFilterForQuery, makeOrFiltersForQuery } from '../../lib/filter';
import { stringifyParams, withTransformResponse } from '../../lib/utils';
/**
 * Interceptor to normalize locations data.
 *
 * @param response the axios response
 *
 * @category Query Functions - getLocations
 * @category Interceptor Functions
 */
export const normalizeLocationsResData = (data) => {
    // `_metadata` is not used by clients; contains only `response_time`, which other query fns also remove
    delete data._metadata;
    // `_suggestion_details` is not populated for locations responses
    delete data._suggestion_details;
    return data;
};
export const transformGetLocationsInputForApi = (input) => {
    const params = {};
    const { facet, filter } = input, inputMinusFacetFilter = __rest(input, ["facet", "filter"]);
    if (filter === null || filter === void 0 ? void 0 : filter.and) {
        params.filter = makeAndFiltersForQuery(filter.and);
    }
    if (filter === null || filter === void 0 ? void 0 : filter.or) {
        params._filter = makeOrFiltersForQuery(filter.or);
    }
    if (filter === null || filter === void 0 ? void 0 : filter.not) {
        params['-filter'] = makeNegativeFilterForQuery(filter.not);
    }
    if (facet) {
        params.facet = makeFacetsForQuery(facet);
    }
    return Object.assign(Object.assign({}, params), inputMinusFacetFilter);
};
/**
 * Example query function.
 *
 * @param client the internal client instance
 * @param config the internal client configuration object
 * @param input input parameters for paring down the search results
 *
 * @category Query Functions - getLocations
 * @category Query Functions
 */
export const getLocations = (client, config, input) => {
    const { customerCode } = config;
    return client.get(`/${customerCode}/locations`, {
        params: input,
        paramsSerializer: (input) => {
            const transformedParams = transformGetLocationsInputForApi(input);
            return stringifyParams(transformedParams);
        },
        transformResponse: withTransformResponse(client, [
            normalizeLocationsResData
        ])
    });
};
//# sourceMappingURL=getLocations.js.map